export default __webpack_public_path__ + "static/media/kadra_ala.44817d7b.jpeg";